import { render, staticRenderFns } from "./DealerLogList.vue?vue&type=template&id=5bb81804&"
import script from "./DealerLogList.vue?vue&type=script&lang=js&"
export * from "./DealerLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDataTable,VDialog})
